package com.hyperether.goodjob.scenes.addNew.components

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.width
import androidx.compose.material.DropdownMenu
import androidx.compose.material.Text
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.onGloballyPositioned
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.toSize
import com.hyperether.goodjob.getPlatformChecker
import com.hyperether.goodjob.scenes.components.TrailingDropdownIconButton
import com.hyperether.goodjob.scenes.components.noRippleClickable
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.theme.InputBorderColor
import com.hyperether.goodjob.theme.TextColor
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp

@Composable
fun AddInputField(
    text: MutableState<String>,
    label: String,
    placeholder: String,
    dropdownItems: Map<String, String>,
    keyboardInputEnabled: Boolean
) {
    var expanded by remember { mutableStateOf(false) }
    val textFieldSize = remember { mutableStateOf(Size.Zero) }

    Box(
        modifier = if (getPlatformChecker().isMobile())
            Modifier
                .fillMaxWidth()
        else Modifier
            .fillMaxWidth()
            .height(56.toScaleDp())
    ) {
        OutlinedTextField(
            value = text.value,
            onValueChange = {
                text.value = it
            },
            label = {
                Text(
                    label, fontSize = 14.toScaleSp(), color = TextColor,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
            },
            textStyle = TextStyle(fontSize = 14.toScaleSp()),
            singleLine = true,
            placeholder = {
                Text(
                    placeholder, fontSize = 14.toScaleSp(), color = Color.LightGray,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
            },
            modifier = Modifier
                .fillMaxSize()
                .onGloballyPositioned { coordinates ->
                    textFieldSize.value = coordinates.size.toSize()
                }
                .noRippleClickable {
                    expanded = !expanded
                },
            trailingIcon = {
                TrailingDropdownIconButton(onClick = { expanded = !expanded })
            },
            enabled = keyboardInputEnabled,
            readOnly = !keyboardInputEnabled,
            colors = OutlinedTextFieldDefaults.colors(
                disabledBorderColor = InputBorderColor,
                unfocusedBorderColor = InputBorderColor,
                disabledTextColor = TextColor,
                focusedBorderColor = BlueApp,
                cursorColor = BlueApp
            ),
        )

        if (dropdownItems.isNotEmpty()) {
            DropdownMenu(
                expanded = expanded,
                onDismissRequest = { expanded = false },
                modifier = Modifier.width(with(LocalDensity.current) { textFieldSize.value.width.toDp() })
            ) {
                dropdownItems.forEach { item ->
                    DropdownMenuItem(
                        modifier = Modifier.height(56.toScaleDp()),
                        onClick = {
                            text.value = item.key
                            expanded = false
                        },
                        text = {
                            Text(
                                item.key,
                                maxLines = 1,
                                fontSize = 14.toScaleSp(),
                                overflow = TextOverflow.Ellipsis
                            )
                        }
                    )
                }
            }
        }
    }
}
